import React from "react";
import { Box, Flex, HStack, Icon, MenuItem, Text } from "@chakra-ui/react";
import { IoCameraOutline, IoCheckmarkCircle, IoCreateOutline, IoSparklesOutline } from "react-icons/io5";

const TASKS = [
  {
    id: "photo",
    title: "Add a photo",
    doneTitle: "Photo added",
    detail: "So people recognize you",
    action: "Add",
    icon: IoCameraOutline,
  },
  {
    id: "bio",
    title: "Write a bio",
    doneTitle: "Bio added",
    detail: "A line about you",
    action: "Write",
    icon: IoCreateOutline,
  },
  {
    id: "interests",
    title: "Pick your interests",
    doneTitle: "Interests picked",
    detail: "For better event matches",
    action: "Pick",
    icon: IoSparklesOutline,
  },
];

// Checklist shown in the account menu until a photo, a bio, and at least
// one interest are saved. Completed steps stay visible so the progress is obvious.
export const ProfileTasks = ({ hasPhoto, hasBio, hasInterests, onSelect }) => {
  const doneById = { photo: hasPhoto, bio: hasBio, interests: hasInterests };
  const doneCount = TASKS.filter((task) => doneById[task.id]).length;
  const remaining = TASKS.length - doneCount;
  if (remaining === 0) return null;

  return (
    <Box mx={2} mb={1} px={2.5} pt={2.5} pb={1.5} bg="blue.50" borderRadius="lg">
      <HStack justify="space-between" px={1} mb={1.5}>
        <Text fontSize="xs" fontWeight="700" color="gray.800">
          Finish your profile
        </Text>
        <Text fontSize="xs" fontWeight="700" color="#508cf7">
          {remaining} left
        </Text>
      </HStack>
      <Box mx={1} mb={1.5} h="4px" bg="blackAlpha.100" borderRadius="full" overflow="hidden">
        <Box
          h="4px"
          w={`${(doneCount / TASKS.length) * 100}%`}
          bg="#508cf7"
          borderRadius="full"
          transition="width 0.25s ease"
        />
      </Box>
      {TASKS.map((task) =>
        doneById[task.id] ? (
          <HStack key={task.id} spacing={2.5} px={1} py={1.5} opacity={0.75}>
            <Icon as={IoCheckmarkCircle} boxSize={4} color="green.500" />
            <Text fontSize="sm" color="gray.600">
              {task.doneTitle}
            </Text>
          </HStack>
        ) : (
          <MenuItem
            key={task.id}
            onClick={() => onSelect(task.id)}
            borderRadius="md"
            px={1}
            py={1.5}
            bg="transparent"
            _hover={{ bg: "white" }}
            _focus={{ bg: "white" }}
          >
            <HStack spacing={2.5} w="full" align="center">
              <Flex
                boxSize="28px"
                borderRadius="full"
                bg="white"
                align="center"
                justify="center"
                flexShrink={0}
              >
                <Icon as={task.icon} boxSize="15px" color="#508cf7" />
              </Flex>
              <Box flex="1" minW={0} textAlign="left">
                <Text fontSize="sm" fontWeight="600" color="gray.800" lineHeight="1.2">
                  {task.title}
                </Text>
                <Text fontSize="xs" color="gray.500" lineHeight="1.2">
                  {task.detail}
                </Text>
              </Box>
              <Text fontSize="xs" fontWeight="700" color="#508cf7" flexShrink={0}>
                {task.action}
              </Text>
            </HStack>
          </MenuItem>
        )
      )}
    </Box>
  );
};
